"use client";

import { useEffect } from "react";

import { updateClientMetaTag } from "../../utils/updateClientMetaTag";
import { capitalizeFirstLetter } from "../../utils/capitalizeFirstLetter";

const isEconomy = process.env.NEXT_PUBLIC_UI_THEME === "ekonomi";
const siteName = isEconomy ? "Omni Ekonomi" : "Omni";

const CategoryClientMetaData = ({
  isEconomy,
  categoryTitle,
}: {
  isEconomy: boolean;
  categoryTitle: string;
}) => {
  useEffect(() => {
    const title = `${siteName} - ${capitalizeFirstLetter(categoryTitle)}`;

    const updateLatestNewsMetaTags = () => {
      const siteUrl = isEconomy
        ? `https://omniekonomi.se/${categoryTitle}`
        : `https://omni.se/t/${categoryTitle}`;
      const description = `Senaste nytt från ${categoryTitle} kategorin.`;
      const siteLogo = isEconomy
        ? "/images/logo-ekonomi.png"
        : "/images/logo-core.png";

      // Update the title
      document.title = title;

      // Update meta tags
      updateClientMetaTag("description", description);

      updateClientMetaTag("og:title", title, "property");
      updateClientMetaTag("og:description", description, "property");
      updateClientMetaTag("og:url", siteUrl, "property");
      updateClientMetaTag("og:site_name", siteName, "property");
      updateClientMetaTag("og:type", "website", "property");
      updateClientMetaTag("og:image", siteLogo, "property");
      updateClientMetaTag("og:locale", "sv_SE", "property");

      updateClientMetaTag("twitter:title", title, "name");
      updateClientMetaTag("twitter:description", description, "name");
      updateClientMetaTag(
        "twitter:site",
        isEconomy ? "@OmniEkonomi" : "@omni_red",
        "name",
      );
      updateClientMetaTag(
        "twitter:creator",
        isEconomy ? "@OmniEkonomi" : "@omni_red",
        "name",
      );
      updateClientMetaTag("twitter:image", siteLogo, "name");

      updateClientMetaTag("canonical", siteUrl, "property");
    };
    const shouldUpdateMetaTags = document.title !== title;

    if (shouldUpdateMetaTags) updateLatestNewsMetaTags();
  }, [isEconomy, categoryTitle]);

  return null;
};

export { CategoryClientMetaData };
